import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { currency } from 'src/config';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { IProposition } from 'src/model';

interface IEvaluationPropositionCardProps {
  proposition: IProposition;
}

export const EvaluationPropositionCard: React.SFC<
  IEvaluationPropositionCardProps & IGlobalContextProps
> = ({ context, proposition }) => {
  const { project } = context;
  const dateCalculation = (startingDate: Date, endingDate: Date) => {
    const duration = Math.floor(
      (new Date(endingDate).getTime() - new Date(startingDate).getTime()) /
        (1000 * 60 * 60 * 24)
    );
    return duration > 0 ? duration : 0;
  };

  return (
    <Row className='d-flex align-items-center rounded bg-white p-3 mt-4'>
      <Col className='d-flex align-items-center pl-0' md='2' xs='auto'>
        <div>
          {project && <span style={{ fontSize: '18px' }}>{project.title}</span>}
        </div>
      </Col>
      {proposition.startingDate && (
        <Col className='d-flex flex-column' md='2' xs='auto'>
          <span
            className='text-uppercase text-grey'
            style={{ fontSize: '10px', opacity: 0.5 }}
          >
            Date de
            <br />
            démarrage
          </span>
          <span className='text-secondary' style={{ fontSize: '24px' }}>
            {new Date(proposition.startingDate).toLocaleDateString()}
          </span>
        </Col>
      )}
      {project && project.meta.lastModified && (
        <Col className='d-flex flex-column' md='2' xs='auto'>
          <span
            className='text-uppercase text-grey'
            style={{ fontSize: '10px', opacity: 0.5 }}
          >
            Date de
            <br />
            clôture
          </span>
          <span className='text-secondary' style={{ fontSize: '24px' }}>
            {new Date(project.meta.lastModified).toLocaleDateString()}
          </span>
        </Col>
      )}
      {proposition.startingDate && (
        <Col className='d-flex flex-column' md='2' xs='auto'>
          <span
            className='text-uppercase text-grey'
            style={{ fontSize: '10px', opacity: 0.5 }}
          >
            Durée du projet
            <br />
            en jours
          </span>
          <span className='text-secondary' style={{ fontSize: '24px' }}>
            {dateCalculation(
              new Date(proposition.startingDate),
              new Date(proposition.meta.lastModified)
            )}
          </span>
        </Col>
      )}
      {proposition.estimatedEndDate && (
        <Col className='d-flex flex-column' md='2' xs='auto'>
          <span
            className='text-uppercase text-grey'
            style={{ fontSize: '10px', opacity: 0.5 }}
          >
            Jours de
            <br />
            retard
          </span>
          <span className='text-secondary' style={{ fontSize: '24px' }}>
            {dateCalculation(
              new Date(proposition.estimatedEndDate),
              new Date(proposition.meta.lastModified)
            )}
          </span>
        </Col>
      )}
      {proposition.finalPrice && (
        <Col className='d-flex flex-column pr-0' md='2' xs='auto'>
          <span
            className='text-uppercase text-grey'
            style={{ fontSize: '10px', opacity: 0.5 }}
          >
            Valeur de la
            <br />
            prestation
          </span>
          <span className='text-secondary' style={{ fontSize: '24px' }}>
            {`${proposition.finalPrice} ${currency[proposition.currency]}`}
          </span>
        </Col>
      )}
    </Row>
  );
};

export const EvaluationPropositionCardWithGlobalContext = withGlobalContext(
  EvaluationPropositionCard
);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectEvaluation/EvaluationProposition/EvaluationPropositionCard.tsx